// import React from 'react';
// import '../../common/SubNavbar.css'
// import '../../common/CommonText.css'
// import { Link } from 'react-router-dom';

// const PageHeader = ({ pageName, nestedpageName, linkTo = '' }) => {
//   const className = nestedpageName ? 'lt-gray' : 'blue';

//   return (
//     <div className='page-name-left'>
//       <div className='svg-logo svg-logo-home'>
//         <svg className='home-icon' width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M8.3264 0.114948C8.23176 0.0404553 8.1152 0 7.9952 0C7.8752 0 7.75864 0.0404553 7.664 0.114948L0 6.14853L0.662933 6.99501L1.6 6.2573V12.9231C1.60056 13.2085 1.71313 13.4821 1.91304 13.6839C2.11296 13.8858 2.38394 13.9994 2.66667 14H13.3333C13.6161 13.9994 13.887 13.8858 14.087 13.6839C14.2869 13.4821 14.3994 13.2085 14.4 12.9231V6.26215L15.3371 6.99986L16 6.15338L8.3264 0.114948ZM9.06667 12.9231H6.93333V8.61528H9.06667V12.9231ZM10.1333 12.9231V8.61528C10.1333 8.32965 10.021 8.05573 9.82091 7.85376C9.62088 7.65179 9.34956 7.53833 9.06667 7.53833H6.93333C6.65044 7.53833 6.37913 7.65179 6.17909 7.85376C5.97905 8.05573 5.86667 8.32965 5.86667 8.61528V12.9231H2.66667V5.41783L8 1.22312L13.3333 5.42321V12.9231H10.1333Z" fill="#606060"/>

//         </svg>
//         <Link to="/dashboard" className=' lt-gray normal-text no-underline'> Home &gt; </Link>
//         {linkTo ? (
//           <Link to={linkTo} className={`normal-text no-underline ${className}`}>
//             {pageName}
//           </Link>
//         ) : (
//           <span className={`normal-text no-underline ${className}`}>{pageName}</span>
//         )}
//         {nestedpageName && (
//           <span className='page-header blue normal-text'> {nestedpageName}</span>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PageHeader;

import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../common/SubNavbar.css";
import "../../common/CommonText.css";
import "./Pageheader.css";
import { generateBreadcrumbsFromPageName } from "../../../utils/breadcrumbGenerator";
// import useSidebarStore from '../../../store/sidebarStore';
import { useTranslation } from "react-i18next";

const PageHeader = ({
  breadcrumbs = [],
  pageName = "",
  nestedpageName = "",
}) => {
  // const setSelectedPath = useSidebarStore(state => state.setSelectedPath);
  const location = useLocation();
  const { t } = useTranslation();
  // Generate breadcrumbs from pageName/nestedpageName if breadcrumbs array is empty
  const finalBreadcrumbs =
    breadcrumbs.length > 0
      ? breadcrumbs
      : generateBreadcrumbsFromPageName(
          pageName,
          nestedpageName,
          location.pathname,
        );

  // Set selected path on component mount/route change
  // useEffect(() => {
  //   setSelectedPath(location.pathname);
  // }, [location.pathname, setSelectedPath]);

  // const handleLinkClick = (path) => {
  //   setSelectedPath(path);
  // };

  // useEffect(() =>{
  //   console.log('Fineal ',finalBreadcrumbs)
  // },[finalBreadcrumbs])

  return (
    <div className="page-name-left">
      <div className="svg-logo svg-logo-home">
        {/* Home Icon */}
        <svg
          className="home-icon"
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.3264 0.114948C8.23176 0.0404553 8.1152 0 7.9952 0C7.8752 0 7.75864 0.0404553 7.664 0.114948L0 6.14853L0.662933 6.99501L1.6 6.2573V12.9231C1.60056 13.2085 1.71313 13.4821 1.91304 13.6839C2.11296 13.8858 2.38394 13.9994 2.66667 14H13.3333C13.6161 13.9994 13.887 13.8858 14.087 13.6839C14.2869 13.4821 14.3994 13.2085 14.4 12.9231V6.26215L15.3371 6.99986L16 6.15338L8.3264 0.114948ZM9.06667 12.9231H6.93333V8.61528H9.06667V12.9231ZM10.1333 12.9231V8.61528C10.1333 8.32965 10.021 8.05573 9.82091 7.85376C9.62088 7.65179 9.34956 7.53833 9.06667 7.53833H6.93333C6.65044 7.53833 6.37913 7.65179 6.17909 7.85376C5.97905 8.05573 5.86667 8.32965 5.86667 8.61528V12.9231H2.66667V5.41783L8 1.22312L13.3333 5.42321V12.9231H10.1333Z"
            fill="#606060"
          />
        </svg>

        {/* Home Link */}
        <Link
          to="/dashboard"
          className="lt-gray normal-text no-underline"
          // onClick={() => handleLinkClick('/dashboard')}
        >
          {t("Home")}
        </Link>

        {/* Dynamic Breadcrumbs */}
        {finalBreadcrumbs.map((crumb, index) => {
          const isLast = index === finalBreadcrumbs.length - 1;
          const className = isLast ? "blue" : "lt-gray";

          return (
            <React.Fragment key={index}>
              <span className="lt-gray normal-text"> &gt; </span>
              {crumb.path && !isLast ? (
                <Link
                  to={crumb.path}
                  className={`normal-text no-underline ${className}`}
                  // onClick={() => handleLinkClick(crumb.path)}
                >
                  {t(crumb.label)}
                </Link>
              ) : (
                <span className={`normal-text no-underline ${className}`}>
                  {t(crumb.label)}
                </span>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default PageHeader;
